import React from 'react';
import Icon from '../ui/Icon';

const BalanceCard = ({ balance, currency = 'GHS', onTopUp, isLoading }) => {
  return (
    <div
      className="mx-5 mt-5 rounded-3xl p-6 animate-fadeUp relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 60%, #818cf8 100%)',
        boxShadow: '0 8px 32px rgba(99,102,241,0.35), 0 2px 8px rgba(99,102,241,0.2)',
      }}
    >
      {/* Decorative circles */}
      <div
        className="absolute -top-8 -right-8 w-32 h-32 rounded-full pointer-events-none"
        style={{ background: 'rgba(255,255,255,0.07)' }}
      />
      <div
        className="absolute -bottom-10 -left-6 w-40 h-40 rounded-full pointer-events-none"
        style={{ background: 'rgba(255,255,255,0.05)' }}
      />

      <div className="relative">
        <div className="flex items-center gap-2 mb-4">
          <div
            className="w-8 h-8 rounded-xl flex items-center justify-center"
            style={{ background: 'rgba(255,255,255,0.2)' }}
          >
            <Icon name="wallet" size={16} className="text-white" />
          </div>
          <span className="font-dm text-xs font-medium uppercase tracking-widest text-white/70">
            Wallet Balance
          </span>
        </div>

        {isLoading ? (
          <div className="h-10 w-40 rounded-2xl shimmer-bg mb-5" />
        ) : (
          <p className="font-syne font-bold text-white mb-5" style={{ fontSize: 32, letterSpacing: '-0.5px' }}>
            {currency}{' '}
            {balance != null
              ? Number(balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '0.00'}
          </p>
        )}

        <button
          onClick={onTopUp}
          className="flex items-center gap-2 px-5 py-2.5 rounded-2xl font-dm font-semibold text-sm press-scale transition-all"
          style={{
            background: 'rgba(255,255,255,0.18)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: '#fff',
            backdropFilter: 'blur(8px)',
          }}
        >
          <Icon name="plus" size={15} strokeWidth="2.5" />
          Top Up Wallet
        </button>
      </div>
    </div>
  );
};

export default BalanceCard;
